<app-header></app-header>

<div class="container-fluid bg-primary py-5 bg-header mrb-90">
    <div class="row py-5">
        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 class="display-4 text-white">Our Blogs</h1>
            <a routerLink="/" class="h5 text-white">Home</a>
            <i class="far fa-circle text-white px-2"></i>
            <a routerLink="/blog-grid" class="h5 text-white">Our Blogs</a>
        </div>
    </div>
</div>

<!-- Blog Start -->
<div class="container-fluid py-5">
  <div class="container">
    <div class="row g-5">

      <!-- Blog Posts -->
      <div class="col-lg-8">
        <div class="row g-5">

          <div class="col-lg-6" *ngFor="let blog of blogs">
            <div class="blog-item bg-light rounded overflow-hidden">

              <div class="blog-img position-relative overflow-hidden">
                <img class="img-fluid" [src]="'assets/images/' + blog.image" [alt]="blog.title">

                <a class="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4">
                  {{blog.category}}
                </a>
              </div>

              <div class="p-4">

                <div class="d-flex mb-3">
                  <small class="me-3">
                    <i class="far fa-user text-primary me-2"></i>{{blog.author}}
                  </small>

                  <small>
                    <i class="far fa-calendar-alt text-primary me-2"></i>{{blog.date}}
                  </small>
                </div>

                <h4 class="mb-3">{{blog.title}}</h4>

                <p>{{blog.desc}}</p>

                <a class="text-uppercase">
                  Read More <i class="bi bi-arrow-right"></i>
                </a>

              </div>
            </div>
          </div>

          <div class="col-12">
            <nav aria-label="Page navigation">
              <ul class="pagination pagination-lg m-0">
                <li class="page-item disabled">
                  <a class="page-link rounded-0" href="#" aria-label="Previous">
                    <span aria-hidden="true"><i class="bi bi-arrow-left"></i></span>
                  </a>
                </li>
                <li class="page-item active"><a class="page-link" href="#">1</a></li>
                <li class="page-item"><a class="page-link" href="#">2</a></li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item">
                  <a class="page-link rounded-0" href="#" aria-label="Next">
                    <span aria-hidden="true"><i class="bi bi-arrow-right"></i></span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <!-- Sidebar -->
      <div class="col-lg-4">
        <!-- Search Form Start -->
        <div class="mb-5">
            <div class="input-group">
                <input type="text" class="form-control p-3" placeholder="Keyword">
                <button class="btn btn-primary px-4"><i class="bi bi-search"></i></button>
            </div>
        </div>
        <!-- Search Form End -->

        <!-- Categories -->
        <div class="mb-5">
          <div class="section-title section-title-sm position-relative pb-3 mb-4">
              <h3 class="mb-0">Categories</h3>
          </div>

          <div class="d-flex flex-column">

            <a *ngFor="let cat of categories"
              class="h5 fw-medium bg-light rounded py-2 px-3 mb-2">

              <i class="bi bi-arrow-right me-2"></i>{{cat}}

            </a>

          </div>
        </div>


        <!-- Recent Posts -->
        <div class="mb-5">

          <div class="section-title section-title-sm position-relative pb-3 mb-4">
              <h3 class="mb-0">Recent Post</h3>
          </div>

          <div *ngFor="let post of recentPosts"
            class="d-flex rounded overflow-hidden mb-3">

            <img class="img-fluid"
              style="width:100px;height:100px;object-fit:cover"
              [src]="'assets/images/' + post.image"
              [alt]="post.title">

            <a class="h5 d-flex align-items-center bg-light px-3 mb-0">

              {{post.title}}

            </a>

          </div>

        </div>


        <!-- Tags -->
        <div class="mb-5">

          <div class="section-title section-title-sm position-relative pb-3 mb-4">
              <h3 class="mb-0">Tags</h3>
          </div>

          <div class="d-flex flex-wrap m-n1">

            <a *ngFor="let tag of tags"
              class="btn btn-light m-1">

              {{tag}}

            </a>

          </div>

        </div>

        <!-- Plain Text Start -->
        <div class="wow slideInUp" data-wow-delay="0.1s">
            <div class="section-title section-title-sm position-relative pb-3 mb-4">
                <h3 class="mb-0">About Us</h3>
            </div>
            <div class="bg-light text-left pd-30">
                <p>At Delex, we deliver high-performance web solutions that help you grow your business online. From design to deployment, we're your trusted digital partner.</p>
                <a routerLink="/blog-standard" class="btn btn-primary border-radius py-2 px-4">Read More</a>
            </div>
        </div>
        <!-- Plain Text End -->
      </div>

    </div>
  </div>
</div>
<!-- Blog Start -->

<!-- Brands Start -->
<div class="container-fluid">
    <div class="container py-5 mb-5">
        <div class="bg-white">
            <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr vendor-carousel">
                <ng-template carouselSlide *ngFor="let brand of brandStore">
                    <div class="client-box">
                        <a href="#."><img src="assets/images/{{brand.img}}" alt="brand-img"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- Brands End -->
